import React from 'react';
import { PageHeading } from 'web-ui-components/lib/typography/headings';
import { SectionHeading } from 'web-ui-components/lib/molecules/text';
import { GenericDivider } from 'web-ui-components/lib/layout/content';
import { ConditionalPanel } from 'web-ui-components/lib/layout/content';
import { Form } from 'react-final-form';
import PropTypes from '../../types';
import { Content } from '../../infrastructure/content';
import Title from './components/Title';
import FirstName from './components/FirstName';
import MiddleName from './components/MiddleName';
import LastName from './components/LastName';
import DateField from './components/DateField';
import AuthorisedSignatory from './components/AuthorisedSignatory';
import OwnCompany from './components/OwnCompany';
import ResidentialStatus from './components/ResidentialStatus';
import CompanyDirector from './components/CompanyDirector';
import PercentPersonOwnCompany from './components/PercentPersonOwnCompany';
import Submit from '../../components/Submit';
import AddressComponent from '../../components/Address';
import DateMoveComponent from '../../components/dateMove';
import { TYPE_UK_ADDRESS, RADIO_VALUE_YES, RADIO_VALUE_NO } from '../../utils/constants';
import { renderAddressComponent } from './components/DateAddressWrapper';
import { clearFormFields, isCardError } from './utils/personaDetailsUtils';
import { ButtonComponent } from '../../components/ButtonComponent';
import { onKeyPress } from '../../utils';
import ResidentialStatusOther from './components/ResidentialStatusOther';
import TitleOther from './components/TitleOther';
import { renderCardError } from '../../utils/cardsError';

const PersonDetailsPage = ({
  savePersonDetails,
  isSoleTrader,
  officerInfo,
  addressHistory,
  currentOfficerNumber,
  onOfficerValueChange,
  showSubmit
}) => (
  <Form
    onSubmit={values => {
      if (!isCardError(values, isSoleTrader)) {
        savePersonDetails(values, currentOfficerNumber);
      }
    }}
    initialValues={officerInfo}
    render={({ handleSubmit, values }) => {
      if (showSubmit) {
        clearFormFields(values);
      }
      return (
        <form
          onSubmit={handleSubmit}
          onKeyPress={onKeyPress}
          onChange={e => {
            if (currentOfficerNumber && currentOfficerNumber >= 0) {
              onOfficerValueChange({
                name: e.target.name,
                value: e.target.value,
                index: currentOfficerNumber
              });
            }
          }}
        >
          <div>
            <Content>
              {({
                personDetailsHeader,
                personDetailsHeaderSoleTrader,
                personDetailsSubHeader,
                personDetailsSubHeaderSoleTrader,
                personDetailsAddressDetailsHeader,
                personDetailsLtdNoteMessage,
                personDetailsSoleNoteMessage,
                PreviousAddressTitle,
                PreviousAddress
              }) => (
                <div>
                  <PageHeading>
                    {isSoleTrader ? personDetailsHeaderSoleTrader : personDetailsHeader}
                  </PageHeading>
                  <p>{isSoleTrader ? personDetailsSubHeaderSoleTrader : personDetailsSubHeader}</p>
                  <Title values={values} />
                  {values && values.title === 'Other' && (
                    <ConditionalPanel isVisible>
                      <TitleOther />
                    </ConditionalPanel>
                  )}
                  <FirstName />
                  <MiddleName />
                  <LastName />
                  <DateField />
                  <AuthorisedSignatory values={values} />
                  {values.authorisedSignatory && !isSoleTrader && (
                    <div>
                      <OwnCompany values={values} />
                      {values.ownCompany === RADIO_VALUE_YES && (
                        <PercentPersonOwnCompany values={values} />
                      )}
                      {(values.percentPersonOwnCompany ||
                        (values.authorisedSignatory === 'Yes' &&
                          values.ownCompany === RADIO_VALUE_NO)) && (
                        <CompanyDirector values={values} />
                      )}
                    </div>
                  )}
                  {validateAuthorizedSignitoriesConditions(values, isSoleTrader) && (
                    <div>
                      <GenericDivider />
                      <SectionHeading heading1={personDetailsAddressDetailsHeader} />
                      <AddressComponent
                        key={TYPE_UK_ADDRESS}
                        type={TYPE_UK_ADDRESS}
                        formValues={values}
                        isPostCodeOnly={true}
                        currentIndex={currentOfficerNumber}
                      />
                      <div>
                        <DateMoveComponent
                          currentIndex={currentOfficerNumber}
                          type={TYPE_UK_ADDRESS}
                          formValues={values}
                          dateIndex={0}
                        />
                      </div>
                      <ResidentialStatus values={values} />
                      {values && values.residentialStatus === 'Other' && (
                        <ConditionalPanel isVisible>
                          <ResidentialStatusOther />
                        </ConditionalPanel>
                      )}
                      {renderAddressComponent(
                        addressHistory,
                        values,
                        PreviousAddressTitle,
                        PreviousAddress,
                        currentOfficerNumber
                      )}
                    </div>
                  )}
                  {isCardError(values, isSoleTrader) &&
                    renderCardError(
                      isSoleTrader ? personDetailsSoleNoteMessage : personDetailsLtdNoteMessage
                    )}
                </div>
              )}
            </Content>
            {showSubmit ? (
              <Submit />
            ) : (
              <ButtonComponent
                title="Submit"
                onClick={() => {
                  handleSubmit(values);
                }}
              ></ButtonComponent>
            )}
          </div>
        </form>
      );
    }}
  />
);

const validateAuthorizedSignitoriesConditions = (values, isSoleTrader) =>
  (values.authorisedSignatory === 'Yes' && isSoleTrader) ||
  (values.authorisedSignatory === 'Yes' &&
    values.ownCompany === RADIO_VALUE_YES &&
    values.companyDirector &&
    !isSoleTrader) ||
  (!isSoleTrader && values.companyDirector);

PersonDetailsPage.propTypes = {
  savePersonDetails: PropTypes.func.isRequired
};

export default PersonDetailsPage;
